import { Grid, GridItem, Icon, Tooltip, Typography } from "@drone-js/core";
import { HStack, VStack } from "apps/commons/components/Stack";
import type { TaxConfig } from "libs/codegen/property-onboarding";
import isEmpty from "lodash/isEmpty";
import type { FunctionComponent } from "react";
import { TextField } from "../form/TextField";
import { useStaticDataAtomValue } from "../staticDataAtom";

export const TaxInformationController: FunctionComponent<TaxConfig> = ({
    taxIdLabel,
    taxIdRegex,
    taxIdInvalidMessage,
    permanentAccountNumberLabel,
    permanentAccountNumberRegex,
    permanentAccountNumberRequiredMessage,
    permanentAccountNumberInvalidMessage,
}) => {
    const {
        cmsData: {
            publish: { taxInformation },
            profile: { taxInformationTooltip },
        },
    } = useStaticDataAtomValue();

    return (
        <VStack gap="16">
            <HStack gap="8" alignItems="center" mb="-12">
                <Typography variant="body-default-strong">{taxInformation}</Typography>
                <Tooltip content={taxInformationTooltip}>
                    <Icon id="fill.symbol.circle-info" size="14" />
                </Tooltip>
            </HStack>
            <Grid>
                {!isEmpty(permanentAccountNumberLabel) && (
                    <GridItem sm={12} md={6}>
                        <TextField
                            label={permanentAccountNumberLabel}
                            field="taxInformation.permanentAccountNumber"
                            rules={{
                                required: permanentAccountNumberRequiredMessage,
                                validate: {
                                    correctFormat: (v) =>
                                        (v !== null && v?.match(new RegExp(permanentAccountNumberRegex)) !== null) ||
                                        permanentAccountNumberInvalidMessage,
                                },
                            }}
                            dataElementName="permanent-account-number"
                        />
                    </GridItem>
                )}
                <GridItem sm={12} md={6}>
                    <TextField
                        label={taxIdLabel}
                        field="taxInformation.taxId"
                        rules={{
                            validate: {
                                correctFormat: (v) =>
                                    v === null || v.match(new RegExp(taxIdRegex)) !== null || taxIdInvalidMessage,
                            },
                        }}
                        dataElementName="gst-id"
                    />
                </GridItem>
            </Grid>
        </VStack>
    );
};
